import { useReservation } from "api/api-hooks/use-create-reservation";
import ConfirmationDialog from "components/confirm-dialog";
import { useBookingGuard } from "hooks/use-booking-guard";
import { useBookingId } from "hooks/use-booking-id";
import { useTranslation } from "react-i18next";
import { useCancelBooking } from "./../api/api-hooks/use-cancel-booking";

export function BookingGuard() {
    const { t } = useTranslation();
    const { blocker } = useBookingGuard();
    const bookingId = useBookingId();
    const { data: booking } = useReservation();

    const title = t("bookingGuard.title");
    const message = t("bookingGuard.message");

    const cancelBooking = useCancelBooking();
    const onConfirmLeave = async () => {
        if (bookingId && booking && !booking.isFinalized()) {
            await cancelBooking.mutateAsync({});
        }

        blocker.proceed?.();
    };

    const onCancel = () => {
        blocker.reset?.();
    };

    return (
        <ConfirmationDialog
            isOpen={blocker?.state === "blocked"}
            title={title}
            message={message}
            primaryAction={onConfirmLeave}
            secondaryAction={onCancel}
            onClose={onCancel}
            primaryButtonText={t("bookingGuard.confirm")}
            secondaryButtonText={t("bookingGuard.abort")}
        />
    );
}
